import React, { useState, useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useCroods } from 'croods';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import { useFormState } from 'react-use-form-state';
import compact from 'lodash/compact';
import head from 'lodash/head';
import objValues from 'lodash/values';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var methodPaths = {
  currentUser: 'auth/validate_token',
  signIn: 'auth/sign_in',
  signOut: 'auth/sign_out',
  forgotPassword: 'auth/password',
  resetPassword: 'auth/password'
};
var methodStateId = {
  deleteAccount: 'delete',
  editProfile: 'edit',
  signIn: 'signIn',
  signOut: 'signOut',
  signUp: 'signUp',
  forgotPassword: 'forgot',
  resetPassword: 'reset'
};
function getBaseOpts (options, method) {
  return _objectSpread2({
    name: 'auth',
    stateId: get(methodStateId, method),
    path: get(methodPaths, method, 'auth'),
    updateRootInfo: true,
    parseResponse: function parseResponse(_ref) {
      var data = _ref.data;
      return data.data;
    }
  }, options);
}

var KEY = 'authCredentials';
function authHeaders() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      storage = _ref.storage,
      storageKey = _ref.storageKey;

  return getParsedHeaders({
    storage: storage,
    storageKey: storageKey
  });
}
function saveHeaders(response, options) {
  var _ref2 = options || {},
      _ref2$storage = _ref2.storage,
      storage = _ref2$storage === void 0 ? localStorage : _ref2$storage,
      _ref2$storageKey = _ref2.storageKey,
      storageKey = _ref2$storageKey === void 0 ? KEY : _ref2$storageKey;

  if (isFunction(storage.setItem)) {
    var credentials = {
      accessToken: get(response, 'headers.access-token'),
      client: get(response, 'headers.client'),
      expiry: get(response, 'headers.expiry'),
      tokenType: get(response, 'headers.token-type'),
      uid: get(response, 'headers.uid')
    };

    if (credentials.accessToken) {
      storage.setItem(storageKey, JSON.stringify(credentials));
    }
  }
}
function clearHeaders(options) {
  var _ref3 = options || {},
      _ref3$storage = _ref3.storage,
      storage = _ref3$storage === void 0 ? localStorage : _ref3$storage,
      _ref3$storageKey = _ref3.storageKey,
      storageKey = _ref3$storageKey === void 0 ? KEY : _ref3$storageKey;

  storage.removeItem(storageKey);
}
function getHeaders(options) {
  var _ref4 = options || {},
      _ref4$storage = _ref4.storage,
      storage = _ref4$storage === void 0 ? localStorage : _ref4$storage,
      _ref4$storageKey = _ref4.storageKey,
      storageKey = _ref4$storageKey === void 0 ? KEY : _ref4$storageKey;

  try {
    //@ts-ignore
    var credentials = JSON.parse(storage.getItem(storageKey));
    return credentials || {};
  } catch (error) {
    return {};
  }
}
function getParsedHeaders(options) {
  var credentials = getHeaders(options);
  return {
    'Access-Token': credentials.accessToken,
    Client: credentials.client,
    Expiry: credentials.expiry,
    'Token-Type': credentials.tokenType,
    Uid: credentials.uid
  };
}

function useCurrentUser(options) {
  var opts = getBaseOpts(_objectSpread2({
    cache: true,
    operation: 'info'
  }, options), 'currentUser');

  var _useCroods = useCroods(opts),
      _useCroods2 = _slicedToArray(_useCroods, 2),
      _useCroods2$ = _useCroods2[0],
      info = _useCroods2$.info,
      fetchingInfo = _useCroods2$.fetchingInfo,
      infoError = _useCroods2$.infoError,
      actions = _useCroods2[1];

  var _useState = useState('pending'),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var initFetch = useCallback(function () {
    var headers = getHeaders(opts);

    if (headers.accessToken) {
      actions.fetch({})();
    } else {
      setStatus('visitor');
      opts.afterFailure && opts.afterFailure({});
    }
  }, [actions, opts]);
  useEffect(function () {
    if (info) {
      setStatus('loggedIn');
    } else {
      initFetch();
    }
  }, [info]);
  return [{
    currentUser: info,
    status: status,
    validating: !!fetchingInfo,
    error: infoError
  }, actions.setInfo];
}

var defaultLoading = 'Authorizing...';

var Authorize = function Authorize(_ref) {
  var Component = _ref.Component,
      _ref$authorizing = _ref.authorizing,
      authorizing = _ref$authorizing === void 0 ? defaultLoading : _ref$authorizing,
      unauthorized = _ref.unauthorized,
      unauthorize = _ref.unauthorize,
      props = _objectWithoutProperties(_ref, ["Component", "authorizing", "unauthorized", "unauthorize"]);

  var _useCurrentUser = useCurrentUser({
    afterFailure: function afterFailure() {
      return unauthorized(currentUser);
    }
  }),
      _useCurrentUser2 = _slicedToArray(_useCurrentUser, 2),
      _useCurrentUser2$ = _useCurrentUser2[0],
      currentUser = _useCurrentUser2$.currentUser,
      validating = _useCurrentUser2$.validating,
      setCurrentUser = _useCurrentUser2[1];

  useLayoutEffect(function () {
    if (unauthorize && currentUser) {
      unauthorize(currentUser) && unauthorized(currentUser);
    }
  }, [currentUser, unauthorize, unauthorized]);
  return validating || !currentUser ? authorizing : /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    currentUser: currentUser,
    setCurrentUser: setCurrentUser
  }));
};

Authorize.propTypes = {
  Component: PropTypes.elementType.isRequired,
  unauthorized: PropTypes.func.isRequired,
  unauthorize: PropTypes.func,
  authorizing: PropTypes.node
};

function useOnUnmount(callback) {
  var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  useEffect(function () {
    return condition ? callback : function () {};
  }, []);
}
function useMounted() {
  var mountedRef = useRef(false);
  useEffect(function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = false;
    };
  }, []);
  return mountedRef.current;
}

// eslint-disable-next-line
var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var validate = function validate(validators) {
  return function (value, values) {
    return head(compact(validators.map(function (validator) {
      return validator(value, values);
    })));
  };
};
var confirmation = function confirmation(name) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be equal to ".concat(name);
  return function (value, values) {
    if (value !== get(values, name)) {
      return message;
    }

    return undefined;
  };
};
var presence = function presence() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Is required";
  return function (value) {
    return value ? undefined : message;
  };
};
var email = function email() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Invalid email";
  return function (value) {
    return value && !EMAIL_REGEX.test(value) ? message : undefined;
  };
};
var minLength = function minLength(chars) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Minimum ".concat(chars, " characters");
  return function (value) {
    return value && value.trim().length < chars ? message : undefined;
  };
};
var getFieldError = function getFieldError(formState) {
  return function (name) {
    return get(formState, "errors.".concat(name));
  };
};
var getFieldProps = function getFieldProps(fields, formState) {
  return function (type, name) {
    var validators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var fieldError = getFieldError(formState);
    return _objectSpread2(_objectSpread2({}, get(fields, type)({
      name: name,
      validate: validate(validators)
    })), {}, {
      error: fieldError(name)
    });
  };
};
var isValidForm = function isValidForm(formState) {
  var additionalCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  return !compact(objValues(formState.errors)).length && additionalCheck(formState);
};
var commonFields = {
  email: ["email", "email", [presence(), email()]],
  password: ["password", "password", [presence(), minLength(8)]],
  passwordConfirmation: ["password", "passwordConfirmation", [confirmation("password", "Password fields must be equal")]]
};
var additionalCheckerPasswordConfirmation = function additionalCheckerPasswordConfirmation(formState) {
  if (formState.values.password === formState.values.passwordConfirmation) return true;
  formState.setFieldError && formState.setFieldError("passwordConfirmation", "Password fields must be equal");
  return false;
};

function useSignIn() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useFormState = useFormState(),
      _useFormState2 = _slicedToArray(_useFormState, 2),
      formState = _useFormState2[0],
      fields = _useFormState2[1];

  var afterSuccess = function afterSuccess(response) {
    saveHeaders(response, options);
    options.afterSuccess && options.afterSuccess(response);
  };

  var opts = _objectSpread2(_objectSpread2({}, getBaseOpts(options, 'signIn')), {}, {
    afterSuccess: afterSuccess
  });

  var _useCroods = useCroods(opts),
      _useCroods2 = _slicedToArray(_useCroods, 2),
      _useCroods2$ = _useCroods2[0],
      signingIn = _useCroods2$.saving,
      error = _useCroods2$.saveError,
      _useCroods2$2 = _useCroods2[1],
      save = _useCroods2$2.save,
      setInfo = _useCroods2$2.setInfo,
      resetState = _useCroods2$2.resetState;

  useOnUnmount(resetState);
  var isFormValid = isValidForm(formState);

  var signIn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
      var saved;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return save({})(data);

            case 2:
              saved = _context.sent;
              saved && setInfo(saved, false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function signIn(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onSubmit = function onSubmit(event) {
    event && event.preventDefault && event.preventDefault();
    return isFormValid ? signIn(formState.values) : undefined;
  };

  var fieldError = getFieldError(formState);
  var fieldProps = getFieldProps(fields, formState);
  return [{
    fields: fields,
    emailProps: fieldProps.apply(null, commonFields.email),
    passwordProps: fieldProps.apply(null, commonFields.password),
    formProps: {
      onSubmit: onSubmit
    },
    fieldProps: fieldProps,
    fieldError: fieldError,
    formState: formState,
    isFormValid: isFormValid,
    signingIn: !!signingIn,
    error: error
  }, signIn];
}

function useSignUp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useFormState = useFormState(),
      _useFormState2 = _slicedToArray(_useFormState, 2),
      formState = _useFormState2[0],
      fields = _useFormState2[1];

  var afterSuccess = function afterSuccess(response) {
    saveHeaders(response, options);
    options.afterSuccess && options.afterSuccess(response);
  };

  var opts = _objectSpread2(_objectSpread2({}, getBaseOpts(options, 'signUp')), {}, {
    afterSuccess: afterSuccess
  });

  var _useCroods = useCroods(opts),
      _useCroods2 = _slicedToArray(_useCroods, 2),
      _useCroods2$ = _useCroods2[0],
      signingUp = _useCroods2$.saving,
      error = _useCroods2$.saveError,
      _useCroods2$2 = _useCroods2[1],
      save = _useCroods2$2.save,
      setInfo = _useCroods2$2.setInfo,
      resetState = _useCroods2$2.resetState;

  useOnUnmount(resetState);
  var isFormValid = isValidForm(formState, additionalCheckerPasswordConfirmation);

  var signUp = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
      var saved;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return save({})(data);

            case 2:
              saved = _context.sent;
              saved && setInfo(saved, false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function signUp(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onSubmit = function onSubmit(event) {
    event && event.preventDefault && event.preventDefault();
    return isFormValid ? signUp(formState.values) : undefined;
  };

  var fieldError = getFieldError(formState);
  var fieldProps = getFieldProps(fields, formState);
  return [{
    fields: fields,
    emailProps: fieldProps.apply(null, commonFields.email),
    passwordProps: fieldProps.apply(null, commonFields.password),
    passwordConfirmationProps: fieldProps.apply(null, commonFields.passwordConfirmation),
    formProps: {
      onSubmit: onSubmit
    },
    fieldProps: fieldProps,
    fieldError: fieldError,
    formState: formState,
    isFormValid: isFormValid,
    signingUp: !!signingUp,
    error: error
  }, signUp];
}

function useSignOut() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var afterSuccess = function afterSuccess(response) {
    clearHeaders(options);
    options.afterSuccess && options.afterSuccess(response);
  };

  var opts = _objectSpread2(_objectSpread2({}, getBaseOpts(options, 'signOut')), {}, {
    operation: 'info',
    afterSuccess: afterSuccess
  });

  var mounted = useMounted();

  var _useCroods = useCroods(opts),
      _useCroods2 = _slicedToArray(_useCroods, 2),
      _useCroods2$ = _useCroods2[0],
      signingOut = _useCroods2$.destroying,
      error = _useCroods2$.destroyError,
      _useCroods2$2 = _useCroods2[1],
      destroy = _useCroods2$2.destroy,
      setInfo = _useCroods2$2.setInfo,
      resetState = _useCroods2$2.resetState;

  useOnUnmount(resetState);
  return [{
    signingOut: !!signingOut,
    error: error
  }, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(callback) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return destroy({})();

            case 2:
              if (typeof callback === 'function') callback();
              mounted && setInfo(null, false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()];
}

function useDeleteAccount() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var afterSuccess = function afterSuccess(response) {
    clearHeaders(options);
    options.afterSuccess && options.afterSuccess(response);
    mounted && setInfo(null, false);
  };

  var opts = _objectSpread2(_objectSpread2({}, getBaseOpts(options, 'deleteAccount')), {}, {
    afterSuccess: afterSuccess
  });

  var mounted = useMounted();

  var _useCroods = useCroods(opts),
      _useCroods2 = _slicedToArray(_useCroods, 2),
      _useCroods2$ = _useCroods2[0],
      currentUser = _useCroods2$.info,
      deleting = _useCroods2$.destroying,
      error = _useCroods2$.destroyError,
      _useCroods2$2 = _useCroods2[1],
      destroy = _useCroods2$2.destroy,
      setInfo = _useCroods2$2.setInfo,
      resetState = _useCroods2$2.resetState;

  useOnUnmount(resetState, !!(deleting || error));
  var id = currentUser ? currentUser.id : undefined;
  return [{
    deleting: !!deleting,
    error: error
  }, destroy({
    id: id
  })];
}

function useEditProfile(options, currentUserOptions) {
  var opts = getBaseOpts(options, 'editProfile');

  var _useCurrentUser = useCurrentUser(currentUserOptions),
      _useCurrentUser2 = _slicedToArray(_useCurrentUser, 2),
      currentUser = _useCurrentUser2[0].currentUser,
      setCurrentUser = _useCurrentUser2[1];

  var _useFormState = useFormState(currentUser),
      _useFormState2 = _slicedToArray(_useFormState, 2),
      formState = _useFormState2[0],
      fields = _useFormState2[1];

  var _useCroods = useCroods(opts),
      _useCroods2 = _slicedToArray(_useCroods, 2),
      _useCroods2$ = _useCroods2[0],
      saving = _useCroods2$.saving,
      error = _useCroods2$.saveError,
      _useCroods2$2 = _useCroods2[1],
      save = _useCroods2$2.save,
      setInfo = _useCroods2$2.setInfo,
      resetState = _useCroods2$2.resetState;

  var isFormValid = isValidForm(formState, additionalCheckerPasswordConfirmation);
  useEffect(function () {
    setInfo(currentUser, false);
  }, []);
  useOnUnmount(resetState);

  var saveData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
      var user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return save({
                method: 'PUT'
              })(data);

            case 2:
              user = _context.sent;
              if (user) setCurrentUser(user);
              return _context.abrupt("return", user);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function saveData(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onSubmit = function onSubmit(event) {
    event && event.preventDefault && event.preventDefault();
    return isFormValid ? saveData(formState.values) : undefined;
  };

  var fieldError = getFieldError(formState);
  var fieldProps = getFieldProps(fields, formState);
  return [{
    currentUser: currentUser,
    fields: fields,
    formProps: {
      onSubmit: onSubmit
    },
    fieldProps: fieldProps,
    fieldError: fieldError,
    formState: formState,
    isFormValid: isFormValid,
    saving: !!saving,
    error: error
  }, saveData];
}

function useForgotPassword() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opts = getBaseOpts(options, 'forgotPassword');

  var _useFormState = useFormState(),
      _useFormState2 = _slicedToArray(_useFormState, 2),
      formState = _useFormState2[0],
      fields = _useFormState2[1];

  var _useCroods = useCroods(opts),
      _useCroods2 = _slicedToArray(_useCroods, 2),
      _useCroods2$ = _useCroods2[0],
      sending = _useCroods2$.saving,
      error = _useCroods2$.saveError,
      _useCroods2$2 = _useCroods2[1],
      save = _useCroods2$2.save,
      resetState = _useCroods2$2.resetState;

  useOnUnmount(resetState, !!(sending || error));
  var isFormValid = isValidForm(formState);

  var send = function send(data) {
    var redirectUrl = options.redirectUrl || '/';
    return save({})(_objectSpread2({
      redirectUrl: redirectUrl
    }, data));
  };

  var onSubmit = function onSubmit(event) {
    event && event.preventDefault && event.preventDefault();
    return isFormValid ? send(formState.values) : undefined;
  };

  var fieldError = getFieldError(formState);
  var fieldProps = getFieldProps(fields, formState);
  return [{
    fields: fields,
    formProps: {
      onSubmit: onSubmit
    },
    emailProps: fieldProps.apply(null, commonFields.email),
    fieldProps: fieldProps,
    fieldError: fieldError,
    formState: formState,
    isFormValid: isFormValid,
    sending: !!sending,
    error: error
  }, send];
}

var DEFAULT_KEY = 'reset_password_token';

function useResetPassword() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$location = options.location,
      location = _options$location === void 0 ? window.location : _options$location,
      _options$tokenKey = options.tokenKey,
      tokenKey = _options$tokenKey === void 0 ? DEFAULT_KEY : _options$tokenKey;
  var opts = getBaseOpts(options, 'resetPassword');

  var _useFormState = useFormState(),
      _useFormState2 = _slicedToArray(_useFormState, 2),
      formState = _useFormState2[0],
      fields = _useFormState2[1];

  var _useCroods = useCroods(opts),
      _useCroods2 = _slicedToArray(_useCroods, 2),
      _useCroods2$ = _useCroods2[0],
      reseting = _useCroods2$.saving,
      error = _useCroods2$.saveError,
      _useCroods2$2 = _useCroods2[1],
      save = _useCroods2$2.save,
      resetState = _useCroods2$2.resetState;

  useOnUnmount(resetState, !!(reseting || error));
  var isFormValid = isValidForm(formState);
  var reset = save({
    method: 'PUT'
  });

  var onSubmit = function onSubmit(event) {
    event && event.preventDefault && event.preventDefault();
    var params = new URLSearchParams(location.search);
    var token = params.get(tokenKey);
    return isFormValid ? reset(_objectSpread2(_objectSpread2({}, formState.values), {}, _defineProperty({}, DEFAULT_KEY, token))) : undefined;
  };

  var fieldError = getFieldError(formState);
  var fieldProps = getFieldProps(fields, formState);
  return [{
    fields: fields,
    passwordProps: fieldProps.apply(null, commonFields.password),
    passwordConfirmationProps: fieldProps.apply(null, commonFields.passwordConfirmation),
    formProps: {
      onSubmit: onSubmit
    },
    fieldProps: fieldProps,
    fieldError: fieldError,
    isFormValid: isFormValid,
    formState: formState,
    reseting: !!reseting,
    error: error
  }, reset];
}

function useProviderAuth(provider) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useSignIn = useSignIn(_objectSpread2({
    path: "auth/social_media/".concat(provider)
  }, options)),
      _useSignIn2 = _slicedToArray(_useSignIn, 2),
      _useSignIn2$ = _useSignIn2[0],
      signingIn = _useSignIn2$.signingIn,
      error = _useSignIn2$.error,
      signIn = _useSignIn2[1];

  return [{
    signingIn: signingIn,
    error: error
  }, signIn];
}

var UserContext = /*#__PURE__*/React.createContext(undefined);

var AuthProvider = function AuthProvider(props) {
  var value = useCurrentUser({});
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: value
  }, props.children);
};

function useUserFromContext() {
  var context = React.useContext(UserContext);

  if (!context) {
    throw new Error('useUserFromContext must be used within a AuthProvider');
  }

  return context;
}

// @ts-ignore
var Auth = Authorize;
var authHeaders$1 = authHeaders;
var useCurrentUser$1 = useCurrentUser;
var useSignIn$1 = useSignIn;
var useSignUp$1 = useSignUp;
var useSignOut$1 = useSignOut;
var useDeleteAccount$1 = useDeleteAccount;
var useEditProfile$1 = useEditProfile;
var useForgotPassword$1 = useForgotPassword;
var useResetPassword$1 = useResetPassword;
var saveHeaders$1 = saveHeaders;
var useProviderAuth$1 = useProviderAuth;
var AuthProvider$1 = AuthProvider;
var useUserFromContext$1 = useUserFromContext;
var index = {
  Auth: Auth,
  authHeaders: authHeaders$1,
  useCurrentUser: useCurrentUser$1,
  useSignIn: useSignIn$1,
  useSignUp: useSignUp$1,
  useSignOut: useSignOut$1,
  useEditProfile: useEditProfile$1,
  useDeleteAccount: useDeleteAccount$1,
  useForgotPassword: useForgotPassword$1,
  useResetPassword: useResetPassword$1,
  saveHeaders: saveHeaders$1,
  useProviderAuth: useProviderAuth$1,
  AuthProvider: AuthProvider$1,
  useUserFromContext: useUserFromContext$1
};

export default index;
export { Auth, AuthProvider$1 as AuthProvider, authHeaders$1 as authHeaders, saveHeaders$1 as saveHeaders, useCurrentUser$1 as useCurrentUser, useDeleteAccount$1 as useDeleteAccount, useEditProfile$1 as useEditProfile, useForgotPassword$1 as useForgotPassword, useProviderAuth$1 as useProviderAuth, useResetPassword$1 as useResetPassword, useSignIn$1 as useSignIn, useSignOut$1 as useSignOut, useSignUp$1 as useSignUp, useUserFromContext$1 as useUserFromContext };
